import React, {Component} from 'react';
import {Link} from "react-router-dom";


// functions
import {scrollUp} from '../functions/functions'
// Images
import Years from "../../assets/img/firstCover.png";
import Services from "../../assets/img/Services.jpg";
import Products from "../../assets/img/Products.jpg";

// Animations
import {Animated} from "react-animated-css";
import {Parallax} from 'react-scroll-parallax';

class HomePage extends Component {

    async componentDidMount() {
        this.props.changeScrollState(false, 'home')
        await scrollUp()
        await this.scrollEvent()
    }

    scrollEvent() {
        if (!this.props.state.menuScrolled && window.pageYOffset === 0) {
            window.addEventListener('scroll', this.chageParentSate)
        }
    }

    chageParentSate = () => {
        if (window.pageYOffset !== 0) {
            this.props.changeScrollState(true, 'home')
            window.removeEventListener('scroll', this.chageParentSate)
        }
    }

    componentWillUnmount() {
        console.log("unmount")
        this.props.changeScrollState(false, 'home')
    }


    render() {
        return (
            <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
                <div className="PageHolder">
                    <div className="FirstContainer">
                        <div className="ImageHolder01">
                            <Parallax
                                className="custom-class"
                                offsetYMax={50}
                                offsetYMin={-50}
                                slowerScrollRate
                                tag="figure"
                            >
                                <img src={Years} alt="" className="Image01"/>
                            </Parallax>
                        </div>
                    </div>
                    <div className="ContentHolder01">
                        <h1 className="Title01 "> <span style={{color: '#D64E25'}}>עקיבא טולוצ'ינסקי</span> קבלנים לעבודות חשמל בע"מ</h1>
                        <p className="TextHolder rtlText">
                        חברת עקיבא טולוצינסקי, הינה חברה הקיימת כמעט כ-100 שנה, ובשנים אלו, עיצבנו את דרכנו שלנו, 
הדרך הזו, היא נר לרגלינו ובאה לידי ביטוי בלמידה מהעבר, הנאה משגרת ההווה ובציפייה לעתיד.
                        </p>
                        <p className="TextHolderOrange rtlText">
                        את עיקר פעילות החברה מנהלת משפחת טולוצ'ינסקי, מהמפעל המתקדם הממוקם בכרמיאל, המעסיק קרוב ל-70 עובדים מיישובי הסביבה ומפעיל עשרות מכונות חכמות, העדכניות ביותר מסוגן בכל תחום בו החברה עוסקת.
הדרך שלנו, שנבנתה בכמעט 100 השנים האחרונות, עיצבה אותנו להיות חדשניים, פורצי דרך ובעלי שאיפה למצוינות.
                        </p>
                        <p className="TextHolder rtlText">היא אינה מתרכזת אך ורק בפן המקצועי, גם הפן החברתי אינו נסתר מן העין, כאשר אנחנו מקפידים לשמור על הצביון המשפחתי של חברתנו, כאשר היום היא הינה בבעלות הדור הרביעי למשפחת טולוצינסקי, ובשיתופי פעולה הדוקים ועקביים עם ספקים המעסיקים ותומכים באוכלוסיות בעלות מוגבלויות וצריכים מיוחדים.
אנחנו מקפידים להתפתח, להתייעל ולהעצים את מגוון השירותים והמוצרים שאנחנו מעניקים ללקוחותינו – הן בארץ והן בעולם. 
מחויבותנו, היא לשמור על סטנדרט האיכות הגבוה ביותר, מקצועיות חסרת פשרות, עקביות לאורך ציר הזמן ועל השירות הנגיש ביותר תוך כדי התאמה למציאות המתחדשת.</p>
                    </div>
                    <div className="FutureContainer">
                        <div className="ContentHolder02">
                            <div className="TextHolder01">
                                <h2 >We build our future</h2>
                                <span>Industry 4.0</span>
                            </div>
                            <div className="ButtonHolder">
                                <Link to="/contact">
                                    <button className="ContactUs">צור קשר</button>
                                </Link>
                                <Link to="/about">
                                    <button className="ReadHistory">קרא על המורשת שלנו</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="ProductsAndServiceConatainer">
                        <div className="ServicesHolder">
                            <div className="ImageHolder02">
                                <img src={Services} className="Image03" alt="תעשייה 4.0"/>
                            </div>
                            <div className="ContentHolder03">
                                <h1 className="rtlText titleGrey">השירותים שלנו</h1>
                                <p className="rtlText">
                                    המפעל שלנו כולל מספר מחלקות שונות העוסקות במגוון תחומי עיסוק רחבים, החל בהזרקות הפלסטיק ועד לעיבוד שבבי, כולל כל מה שנמצא ביניהם. אנחנו מלווים כל לקוח שלנו, קטן או גדול, משלב התכנון והפיתוח של המוצר הנדרש ועד לשלב יצור המוצר הסופי, מורכב ככל שיהיה. רמתה המקצועית של חברת עקיבא טולוצ'ינסקי מאפשרת לה להבטיח, כי השירות הנלווה למוצר, אף הוא יהיה ברמה הראשונה במעלה.
                                </p>
                                <Link to="/services">
                                    <button className="ContactUs rtlText">תראו לי עוד...</button>
                                </Link>
                            </div>
                        </div>
                        <div className="ProductsHolder">
                            <div className="ContentHolder04">
                                <h1 className="rtlText titleGrey" >המוצרים שלנו</h1>
                                <p className="rtlText" >
                                    במפעלנו שבכרמיאל, אנחנו מייצרים אביזרי חשמל במתח נמוך וציוד-קצה.
                                    בזכות הניסיון בן עשרות השנים שלנו, אנחנו דוגלים בגישה הוותיקה, עושים שימוש בחומרי הגלם האיכותיים ביותר,
                                    וכתוצאה מכך, המוצרים שאנחנו מייצרים עמידים יותר מאחרים ומחזיקים עשרות שנים.
                                    בזכות ניסיון זה ובזכותה של הרמה המקצועית אליה הגענו, ביכולתנו להתמודד גם עם משימות ייצור מורכבות של מוצרים המורכבים ממכלול.
                                </p>
                                <Link to="/products">
                                    <button className="ContactUs rtlText">תראו לי עוד...</button>
                                </Link>
                            </div>
                            <div className="ImageHolder03">
                                <img src={Products} className="Image03" alt="תעשייה 4.0" />
                            </div>

                        </div>
                    </div>
                </div>
            </Animated>
        );
    }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.js